import './App.css';
import logo from './logo.png';
import Dictionary from './Dictionary';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

function App() {
  return (
    <div className="App">
      <Navbar sticky="top" className="navbar">
        <Container>
          <Navbar.Brand href="/">
            <img
              src={logo}
              height="60"
              className="d-inline-block align-top"
              alt="Dictionary app logo"
            />
          </Navbar.Brand>
        </Container>
      </Navbar>
      <main>
        <Dictionary />
      </main>
      <footer className="App-footer">
        <small>
          Coded by{' '}
          <a
            href="https://github.com/katgorzynska"
            target="_blank"
            rel="noreferrer noopener"
          >
            Kat Górzyńska
          </a>
        </small>
      </footer>
    </div>
  );
}

export default App;
